import store from 'store/index';
import CalculateLoss from 'pages/fatal-accident-claims/dependency/steps/CalculateLossAndGenerateSchedule.vue';
import ClaimDetails from 'pages/fatal-accident-claims/dependency/steps/ClaimDetails.vue';
import CruBenefits from 'pages/fatal-accident-claims/dependency/steps/CruBenefits.vue';
import Dependants from 'pages/fatal-accident-claims/dependency/steps/TheDependants.vue';
import DependencyOnIncome from 'pages/fatal-accident-claims/dependency/steps/DependencyOnIncome.vue';
import DependencyOnService from 'pages/fatal-accident-claims/dependency/steps/DependencyOnServices.vue';
import FatalAccidentClaims from 'pages/fatal-accident-claims/FatalAccidentClaims.vue';
import DependencyClaim from 'pages/fatal-accident-claims/dependency/DependencyClaim.vue';
import HeadsOfLoss from 'pages/fatal-accident-claims/dependency/steps/HeadsOfLossAndDependency.vue';
import InterimPaymentsAndInterest from 'pages/fatal-accident-claims/dependency/steps/InterimPaymentsAndInterest.vue';
import TheDeceased from 'pages/fatal-accident-claims/dependency/steps/TheDeceased.vue';
import Documents from 'components/documents/Documents.vue';
import DocumentEditor from 'components/documents/DocumentEditor.vue';
import DocumentList from 'components/documents/DocumentList.vue';
import {beforeEnter} from 'services/routingMethods';

export default {
    name: 'fatal::dependency',
    path: 'dependency',
    component: DependencyClaim,
    meta: {
        claimStore: 'fatal/dependency',
    },
    beforeEnter: (to, from, next) => beforeEnter(to, from, next),
    children: [
        {
            name: 'fatal::dependency.step-1',
            path: 'claim-data',
            component: ClaimDetails,
            meta: {
                step: 1,
                name: 'Claim Data',
                store: 'claimDetails'
            },
            beforeEnter: (to, from, next) => beforeEnter(to, from, next),
        },
        {
            name: 'fatal::dependency.step-2',
            path: 'the-deceased',
            component: TheDeceased,
            meta: {
                step: 2,
                name: 'The Deceased',
                store: 'deceased',
            },
            beforeEnter: (to, from, next) => beforeEnter(to, from, next),
        },
        {
            name: 'fatal::dependency.step-3',
            path: 'the-dependent',
            component: Dependants,
            meta: {
                step: 3,
                name: 'The Dependants',
                store: 'dependants',
            },
            beforeEnter: (to, from, next) => beforeEnter(to, from, next),
        },
        {
            name: 'fatal::dependency.step-4',
            path: 'dependency-on-income',
            component: DependencyOnIncome,
            meta: {
                step: 4,
                name: 'Dependency on Income',
                store: 'dependencyOnIncome',
            },
            beforeEnter: (to, from, next) => beforeEnter(to, from, next),
        },
        {
            name: 'fatal::dependency.step-5',
            path: 'dependency-on-services',
            component: DependencyOnService,
            meta: {
                step: 5,
                name: 'Dependency on Services',
                store: 'dependencyOnServices'
            },
            beforeEnter: (to, from, next) => beforeEnter(to, from, next),
        },
        {
            name: 'fatal::dependency.step-6',
            path: 'heads-of-loss',
            component: HeadsOfLoss,
            meta: {
                step: 6,
                name: 'General Damages and Past Heads of Loss',
                store: 'headsOfLoss'
            },
            beforeEnter: (to, from, next) => beforeEnter(to, from, next),
        },
        {
            name: 'fatal::dependency.step-7',
            path: 'cru',
            component: CruBenefits,
            meta: {
                step: 7,
                name: 'CRU Benefits',
                store: 'cru'
            },
            beforeEnter: (to, from, next) => beforeEnter(to, from, next),
        },
        {
            name: 'fatal::dependency.step-8',
            path: 'interim-payments-and-interest',
            component: InterimPaymentsAndInterest,
            meta: {
                step: 8,
                name: 'Interim Payments and Interest',
                store: 'interimPayments'
            },
            beforeEnter: (to, from, next) => beforeEnter(to, from, next),
        },
        {
            name: 'fatal::dependency.step-9',
            path: 'calculate',
            component: CalculateLoss,
            meta: {
                step: 9,
                name: 'Calculate Loss and Generate Schedule',
                store: 'calculateLoss'
            },
            beforeEnter: (to, from, next) => beforeEnter(to, from, next),
        },
        {
            name: 'fatal::dependency.documents',
            path: 'documents',
            component: Documents,
            meta: {
                step: 10,
                name: 'Documents',
                store: 'documents'
            },
            children: [
                {
                    name: 'fatal::dependency.documents.list',
                    path: 'list',
                    component: DocumentList,
                    meta: {
                        step: 10,
                        name: 'List',
                    },
                },
                {
                    name: 'fatal::dependency.documents.editor',
                    path: 'editor/:document_id(\\d+)',
                    // path: 'editor',
                    component: DocumentEditor,
                    meta: {
                        step: 10,
                        name: 'Editor',
                    },
                },
            ],
        },
    ],
};
       


// WEBPACK FOOTER //
// ./src/pages/fatal-accident-claims/dependency/routes.js